import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';
export class LL_0016_VCU_CAN01 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0016_VCU_CAN01',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'AirVolumeFlowStatus',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcList',
              isRead: 'true',
              interval: '257',
              texttableentry: 'StatusDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcHistory',
              isRead: 'true',
              interval: '258',
              texttableentry: 'StatusDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcList',
              isRead: 'true',
              interval: '259',
              texttableentry: 'InfoDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcHistory',
              isRead: 'true',
              interval: '260',
              texttableentry: 'InfoDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcList',
              isRead: 'true',
              interval: '261',
              texttableentry: 'ServiceDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcHistory',
              isRead: 'true',
              interval: '262',
              texttableentry: 'ServiceDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WarningDtcList',
              isRead: 'true',
              interval: '263',
              texttableentry: 'WarningDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcHistory',
              isRead: 'true',
              interval: '264',
              texttableentry: 'WarningDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcHistory',
              isRead: 'true',
              interval: '266',
              texttableentry: 'ErrorDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutdoorAirTemperatureSensor',
              isRead: 'true',
              interval: '327',
              texttableentry: 'OutdoorAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupplyAirTemperatureSensor',
              isRead: 'true',
              interval: '328',
              texttableentry: 'SupplyAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExtractAirTemperatureSensor',
              isRead: 'true',
              interval: '329',
              texttableentry: 'ExtractAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirTemperatureSensor',
              isRead: 'true',
              interval: '330',
              texttableentry: 'ExhaustAirTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumber',
              isRead: 'true',
              interval: '377',
              texttableentry: 'ViessmannIdentificationNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UnitsAndFormats',
              isRead: 'true',
              interval: '382',
              texttableentry: 'UnitsAndFormats',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingTemperatureSetpoint',
              isRead: 'true',
              interval: '395',
              texttableentry: 'CentralHeatingTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutdoorAirHumiditySensor',
              isRead: 'true',
              interval: '419',
              texttableentry: 'OutdoorAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupplyAirHumiditySensor',
              isRead: 'true',
              interval: '420',
              texttableentry: 'SupplyAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExtractAirHumiditySensor',
              isRead: 'true',
              interval: '421',
              texttableentry: 'ExtractAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirHumiditySensor',
              isRead: 'true',
              interval: '422',
              texttableentry: 'ExhaustAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '424',
              texttableentry: 'MixerOneCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPreHeater',
              isRead: 'true',
              interval: '429',
              texttableentry: 'ElectricalPreHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupplyAirVolumeFlowSensor',
              isRead: 'true',
              interval: '431',
              texttableentry: 'SupplyAirVolumeFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirVolumeFlowSensor',
              isRead: 'true',
              interval: '433',
              texttableentry: 'ExhaustAirVolumeFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationStageTargetVolumeFlow',
              isRead: 'true',
              interval: '435',
              texttableentry: 'VentilationStageTargetVolumeFlow',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BypassOperationState',
              isRead: 'true',
              interval: '437',
              texttableentry: 'BypassOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BypassAvailableModes',
              isRead: 'true',
              interval: '439',
              texttableentry: 'BypassAvailableModes',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_Date',
              isRead: 'true',
              interval: '505',
              texttableentry: 'Date',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Time',
              isRead: 'true',
              interval: '506',
              texttableentry: 'Time',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinated',
              isRead: 'true',
              interval: '507',
              texttableentry: 'UniversalTimeCoordinated',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinatedOffset',
              isRead: 'true',
              interval: '508',
              texttableentry: 'UniversalTimeCoordinatedOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NtpStatus',
              isRead: 'true',
              interval: '509',
              texttableentry: 'NtpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_Language',
              isRead: 'true',
              interval: '510',
              texttableentry: 'Language',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhase',
              isRead: 'true',
              interval: '511',
              texttableentry: 'HolidayPhase',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhase',
              isRead: 'true',
              interval: '512',
              texttableentry: 'HolidayAtHomePhase',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitOne',
              isRead: 'true',
              interval: '513',
              texttableentry: 'HolidayPhaseCircuitOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitOne',
              isRead: 'true',
              interval: '514',
              texttableentry: 'HolidayAtHomePhaseCircuitOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitTwo',
              isRead: 'true',
              interval: '515',
              texttableentry: 'HolidayPhaseCircuitTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitTwo',
              isRead: 'true',
              interval: '516',
              texttableentry: 'HolidayAtHomePhaseCircuitTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitThree',
              isRead: 'true',
              interval: '517',
              texttableentry: 'HolidayPhaseCircuitThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitThree',
              isRead: 'true',
              interval: '518',
              texttableentry: 'HolidayAtHomePhaseCircuitThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitFour',
              isRead: 'true',
              interval: '519',
              texttableentry: 'HolidayPhaseCircuitFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitFour',
              isRead: 'true',
              interval: '520',
              texttableentry: 'HolidayAtHomePhaseCircuitFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OperatingHoursTillService',
              isRead: 'true',
              interval: '521',
              texttableentry: 'OperatingHoursTillService',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceDateNext',
              isRead: 'true',
              interval: '522',
              texttableentry: 'ServiceDateNext',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceDateLast',
              isRead: 'true',
              interval: '523',
              texttableentry: 'ServiceDateLast',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationTargetOperationLevel',
              isRead: 'true',
              interval: '533',
              texttableentry: 'VentilationTargetOperationLevel',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetSensorMinMaxAverageStatistics',
              isRead: 'true',
              interval: '569',
              texttableentry: 'ResetSensorMinMaxAverageStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetStatistics',
              isRead: 'true',
              interval: '570',
              texttableentry: 'ResetStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValues',
              isRead: 'false',
              interval: '571',
              texttableentry: 'SetDefaultValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValuesDate',
              isRead: 'true',
              interval: '572',
              texttableentry: 'SetDefaultValuesDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteReset',
              isRead: 'true',
              interval: '573',
              texttableentry: 'RemoteReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteResetCounter',
              isRead: 'true',
              interval: '574',
              texttableentry: 'RemoteResetCounter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatusDate',
              isRead: 'true',
              interval: '576',
              texttableentry: 'SetDeliveryStatusDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeliveryStatusActive',
              isRead: 'true',
              interval: '577',
              texttableentry: 'DeliveryStatusActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionInitialisation',
              isRead: 'true',
              interval: '579',
              texttableentry: 'ProductionInitialisation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerOnCounter',
              isRead: 'true',
              interval: '582',
              texttableentry: 'PowerOnCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationOperationHours',
              isRead: 'true',
              interval: '589',
              texttableentry: 'VentilationOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOperationHours',
              isRead: 'true',
              interval: '590',
              texttableentry: 'ElectronicControlUnitOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InternalWatchDogCounter',
              isRead: 'true',
              interval: '591',
              texttableentry: 'InternalWatchDogCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MacAddressLan',
              isRead: 'true',
              interval: '592',
              texttableentry: 'MacAddressLan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayMac',
              isRead: 'true',
              interval: '593',
              texttableentry: 'GatewayMac',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteLocalNetworkStatus',
              isRead: 'true',
              interval: '602',
              texttableentry: 'GatewayRemoteLocalNetworkStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayApEnable',
              isRead: 'true',
              interval: '603',
              texttableentry: 'GatewayApEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayApDataSet',
              isRead: 'true',
              interval: '604',
              texttableentry: 'GatewayApDataSet',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIp',
              isRead: 'true',
              interval: '607',
              texttableentry: 'GatewayRemoteIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyServer',
              isRead: 'true',
              interval: '609',
              texttableentry: 'ProxyServer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyPort',
              isRead: 'true',
              interval: '610',
              texttableentry: 'ProxyPort',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyUser',
              isRead: 'true',
              interval: '611',
              texttableentry: 'ProxyUser',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyPassword',
              isRead: 'false',
              interval: '612',
              texttableentry: 'ProxyPassword',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyEnabled',
              isRead: 'true',
              interval: '613',
              texttableentry: 'ProxyEnabled',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteUpdateStatus',
              isRead: 'true',
              interval: '614',
              texttableentry: 'RemoteUpdateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RemoteUpdateCounter',
              isRead: 'true',
              interval: '615',
              texttableentry: 'RemoteUpdateCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteEnable',
              isRead: 'true',
              interval: '616',
              texttableentry: 'GatewayRemoteEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSsid',
              isRead: 'false',
              interval: '617',
              texttableentry: 'GatewayRemoteSsid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIpStatic',
              isRead: 'true',
              interval: '618',
              texttableentry: 'GatewayRemoteIpStatic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteScanNetwork',
              isRead: 'true',
              interval: '619',
              texttableentry: 'GatewayRemoteScanNetwork',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticServiceConnectionStatus',
              isRead: 'true',
              interval: '620',
              texttableentry: 'DiagnosticServiceConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ObjectContactDetails',
              isRead: 'true',
              interval: '621',
              texttableentry: 'ObjectContactDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerDetails',
              isRead: 'true',
              interval: '622',
              texttableentry: 'CustomerDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceEngineer',
              isRead: 'true',
              interval: '623',
              texttableentry: 'ServiceEngineer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TechnicalSupport',
              isRead: 'true',
              interval: '624',
              texttableentry: 'TechnicalSupport',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectDetails',
              isRead: 'true',
              interval: '625',
              texttableentry: 'ObjectDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '761',
              texttableentry: 'MixerOneCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '762',
              texttableentry: 'MixerOneCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '763',
              texttableentry: 'MixerOneCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '764',
              texttableentry: 'MixerOneCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '765',
              texttableentry: 'MixerOneCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '766',
              texttableentry: 'MixerOneCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '767',
              texttableentry: 'MixerOneCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSignalStrength',
              isRead: 'true',
              interval: '900',
              texttableentry: 'GatewayRemoteSignalStrength',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceManagerIsRequired',
              isRead: 'true',
              interval: '901',
              texttableentry: 'ServiceManagerIsRequired',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MalfunctionIdentification',
              isRead: 'true',
              interval: '902',
              texttableentry: 'MalfunctionIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplaySettings',
              isRead: 'true',
              interval: '903',
              texttableentry: 'DisplaySettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPostHeater',
              isRead: 'true',
              interval: '905',
              texttableentry: 'ElectricalPostHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UserInterfaceDefaultHomeScreen',
              isRead: 'true',
              interval: '907',
              texttableentry: 'UserInterfaceDefaultHomeScreen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DaylightSavingTimeActive',
              isRead: 'true',
              interval: '912',
              texttableentry: 'DaylightSavingTimeActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentMemoryCecksum',
              isRead: 'true',
              interval: '913',
              texttableentry: 'PersistentMemoryCecksum',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentMemoryLastUpdate',
              isRead: 'true',
              interval: '914',
              texttableentry: 'PersistentMemoryLastUpdate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TradeFairMode',
              isRead: 'true',
              interval: '918',
              texttableentry: 'TradeFairMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalAccessInProgress',
              isRead: 'true',
              interval: '921',
              texttableentry: 'ExternalAccessInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionTraceabilityByte',
              isRead: 'true',
              interval: '922',
              texttableentry: 'ProductionTraceabilityByte',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RealTimeClockStatus',
              isRead: 'true',
              interval: '923',
              texttableentry: 'RealTimeClockStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StartUpWizard',
              isRead: 'true',
              interval: '924',
              texttableentry: 'StartUpWizard',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BuildingType',
              isRead: 'true',
              interval: '927',
              texttableentry: 'BuildingType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitProperty',
              isRead: 'true',
              interval: '933',
              texttableentry: 'MixerOneCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitProperty',
              isRead: 'true',
              interval: '934',
              texttableentry: 'MixerTwoCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitProperty',
              isRead: 'true',
              interval: '935',
              texttableentry: 'MixerThreeCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitProperty',
              isRead: 'true',
              interval: '936',
              texttableentry: 'MixerFourCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrix',
              isRead: 'true',
              interval: '954',
              texttableentry: 'BusTopologyMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecurityAlgorithmNumber',
              isRead: 'true',
              interval: '961',
              texttableentry: 'SecurityAlgorithmNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SparePartNumber',
              isRead: 'true',
              interval: '963',
              texttableentry: 'SparePartNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ProductionDateTime',
              isRead: 'true',
              interval: '969',
              texttableentry: 'ProductionDateTime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InstallationDateTime',
              isRead: 'true',
              interval: '970',
              texttableentry: 'InstallationDateTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '987',
              texttableentry: 'MixerOneCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TestOperationMode',
              isRead: 'true',
              interval: '1003',
              texttableentry: 'TestOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TargetQuickMode',
              isRead: 'true',
              interval: '1006',
              texttableentry: 'TargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentQuickMode',
              isRead: 'true',
              interval: '1007',
              texttableentry: 'CurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupplyAirFan',
              isRead: 'true',
              interval: '1040',
              texttableentry: 'SupplyAirFan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirFan',
              isRead: 'true',
              interval: '1041',
              texttableentry: 'ExhaustAirFan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceIndividualisationPartOne',
              isRead: 'true',
              interval: '1045',
              texttableentry: 'DeviceIndividualisationPartOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FreezeFrame',
              isRead: 'true',
              interval: '1081',
              texttableentry: 'FreezeFrame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OutsideAirBypass',
              isRead: 'true',
              interval: '1088',
              texttableentry: 'OutsideAirBypass',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InsideAirBypass',
              isRead: 'true',
              interval: '1089',
              texttableentry: 'InsideAirBypass',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnvironmentAirQuality',
              isRead: 'true',
              interval: '1090',
              texttableentry: 'EnvironmentAirQuality',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersion',
              isRead: 'true',
              interval: '1131',
              texttableentry: 'ParameterIdentificationVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ItemNumber',
              isRead: 'true',
              interval: '1135',
              texttableentry: 'ItemNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceModeActivation',
              isRead: 'true',
              interval: '1137',
              texttableentry: 'ServiceModeActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BackendConnectionStatus',
              isRead: 'true',
              interval: '1165',
              texttableentry: 'BackendConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetDtcHistory',
              isRead: 'true',
              interval: '1166',
              texttableentry: 'ResetDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeInfoAlarmMessage',
              isRead: 'true',
              interval: '1175',
              texttableentry: 'AcknowledgeInfoAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeWarningAlarmMessage',
              isRead: 'true',
              interval: '1176',
              texttableentry: 'AcknowledgeWarningAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeServiceAlarmMessage',
              isRead: 'true',
              interval: '1177',
              texttableentry: 'AcknowledgeServiceAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeErrorAlarmMessage',
              isRead: 'true',
              interval: '1178',
              texttableentry: 'AcknowledgeErrorAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1192',
              texttableentry: 'MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationNumber',
              isRead: 'true',
              interval: '1213',
              texttableentry: 'ParameterIdentificationNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleOneTwo',
              isRead: 'true',
              interval: '1233',
              texttableentry: 'GatewayRemoteVisibleOneTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleThreeFour',
              isRead: 'true',
              interval: '1234',
              texttableentry: 'GatewayRemoteVisibleThreeFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleFiveSix',
              isRead: 'true',
              interval: '1235',
              texttableentry: 'GatewayRemoteVisibleFiveSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleSevenEight',
              isRead: 'true',
              interval: '1236',
              texttableentry: 'GatewayRemoteVisibleSevenEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleNineTen',
              isRead: 'true',
              interval: '1237',
              texttableentry: 'GatewayRemoteVisibleNineTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AvailableActorSensorComponents',
              isRead: 'true',
              interval: '1238',
              texttableentry: 'AvailableActorSensorComponents',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActorSensorTest',
              isRead: 'true',
              interval: '1239',
              texttableentry: 'ActorSensorTest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixTwo',
              isRead: 'true',
              interval: '1286',
              texttableentry: 'BusTopologyMatrixTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixThree',
              isRead: 'true',
              interval: '1287',
              texttableentry: 'BusTopologyMatrixThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFour',
              isRead: 'true',
              interval: '1288',
              texttableentry: 'BusTopologyMatrixFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFive',
              isRead: 'true',
              interval: '1289',
              texttableentry: 'BusTopologyMatrixFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetServiceInterval',
              isRead: 'true',
              interval: '1411',
              texttableentry: 'ResetServiceInterval',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VolumeFlowControlActivation',
              isRead: 'true',
              interval: '1414',
              texttableentry: 'VolumeFlowControlActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApplicationChecksum',
              isRead: 'true',
              interval: '1451',
              texttableentry: 'ApplicationChecksum',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputOneValue',
              isRead: 'true',
              interval: '1452',
              texttableentry: 'DeviceDigitalInputOneValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputTwoValue',
              isRead: 'true',
              interval: '1453',
              texttableentry: 'DeviceDigitalInputTwoValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputThreeValue',
              isRead: 'true',
              interval: '1454',
              texttableentry: 'DeviceDigitalInputThreeValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputFourValue',
              isRead: 'true',
              interval: '1455',
              texttableentry: 'DeviceDigitalInputFourValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputOneValue',
              isRead: 'true',
              interval: '1456',
              texttableentry: 'DeviceDigitalOutputOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTwoValue',
              isRead: 'true',
              interval: '1457',
              texttableentry: 'DeviceDigitalOutputTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputThreeValue',
              isRead: 'true',
              interval: '1458',
              texttableentry: 'DeviceDigitalOutputThreeValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputFourValue',
              isRead: 'true',
              interval: '1459',
              texttableentry: 'DeviceDigitalOutputFourValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AnalogAdcInputValues',
              isRead: 'true',
              interval: '1466',
              texttableentry: 'AnalogAdcInputValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OemProductVersion',
              isRead: 'true',
              interval: '1494',
              texttableentry: 'OemProductVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputOneValue',
              isRead: 'true',
              interval: '1497',
              texttableentry: 'DeviceAnalogInputOneValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputTwoValue',
              isRead: 'true',
              interval: '1498',
              texttableentry: 'DeviceAnalogInputTwoValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputThreeValue',
              isRead: 'true',
              interval: '1499',
              texttableentry: 'DeviceAnalogInputThreeValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSettingSource',
              isRead: 'true',
              interval: '1504',
              texttableentry: 'TimeSettingSource',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneTargetPositionPercent',
              isRead: 'true',
              interval: '1506',
              texttableentry: 'AccessoryValveOneTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneCurrentPositionPercent',
              isRead: 'true',
              interval: '1507',
              texttableentry: 'AccessoryValveOneCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneMinMaxLimit',
              isRead: 'true',
              interval: '1508',
              texttableentry: 'AccessoryValveOneMinMaxLimit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveTwoTargetPositionPercent',
              isRead: 'true',
              interval: '1509',
              texttableentry: 'AccessoryValveTwoTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveTwoCurrentPositionPercent',
              isRead: 'true',
              interval: '1510',
              texttableentry: 'AccessoryValveTwoCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveTwoMinMaxLimit',
              isRead: 'true',
              interval: '1511',
              texttableentry: 'AccessoryValveTwoMinMaxLimit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LastResetCause',
              isRead: 'true',
              interval: '1527',
              texttableentry: 'LastResetCause',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InstallationWizardInProgress',
              isRead: 'true',
              interval: '1533',
              texttableentry: 'InstallationWizardInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeEnable',
              isRead: 'true',
              interval: '1538',
              texttableentry: 'ZigbeeEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeStatus',
              isRead: 'true',
              interval: '1539',
              texttableentry: 'ZigbeeStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigbeeIdentification',
              isRead: 'true',
              interval: '1540',
              texttableentry: 'ZigbeeIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InternalComponentUsage',
              isRead: 'true',
              interval: '1548',
              texttableentry: 'InternalComponentUsage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FunctionMatrix',
              isRead: 'true',
              interval: '1550',
              texttableentry: 'FunctionMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOdxVersion',
              isRead: 'true',
              interval: '1553',
              texttableentry: 'ElectronicControlUnitOdxVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingSupport',
              isRead: 'true',
              interval: '1554',
              texttableentry: 'HeatingSupport',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LastApplicationUpdate',
              isRead: 'true',
              interval: '1594',
              texttableentry: 'LastApplicationUpdate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersionFactory',
              isRead: 'true',
              interval: '1595',
              texttableentry: 'ParameterIdentificationVersionFactory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MalfunctionUnitBlocked',
              isRead: 'true',
              interval: '1607',
              texttableentry: 'MalfunctionUnitBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupportedFeatures',
              isRead: 'true',
              interval: '1660',
              texttableentry: 'SupportedFeatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyScanStatus',
              isRead: 'true',
              interval: '1691',
              texttableentry: 'BusTopologyScanStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetEnable',
              isRead: 'true',
              interval: '1694',
              texttableentry: 'GatewayEthernetEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetConfig',
              isRead: 'true',
              interval: '1695',
              texttableentry: 'GatewayEthernetConfig',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetIp',
              isRead: 'true',
              interval: '1696',
              texttableentry: 'GatewayEthernetIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetNetworkStatus',
              isRead: 'true',
              interval: '1697',
              texttableentry: 'GatewayEthernetNetworkStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FunctionalSoftwareVersion',
              isRead: 'true',
              interval: '1710',
              texttableentry: 'FunctionalSoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarIntervalFunction',
              isRead: 'true',
              interval: '1719',
              texttableentry: 'SolarIntervalFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputFiveValue',
              isRead: 'true',
              interval: '1720',
              texttableentry: 'DeviceDigitalInputFiveValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalLockActive',
              isRead: 'true',
              interval: '1731',
              texttableentry: 'ExternalLockActive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FixedRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1732',
              texttableentry: 'FixedRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CanInterfaceVersion',
              isRead: 'true',
              interval: '1788',
              texttableentry: 'CanInterfaceVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetElectricalEnergyHistory',
              isRead: 'true',
              interval: '1792',
              texttableentry: 'ResetElectricalEnergyHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ManufacturerProperties',
              isRead: 'true',
              interval: '1835',
              texttableentry: 'ManufacturerProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerDetailsExtensions',
              isRead: 'true',
              interval: '1847',
              texttableentry: 'CustomerDetailsExtensions',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ActivatedFeatures',
              isRead: 'true',
              interval: '2158',
              texttableentry: 'ActivatedFeatures',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputSixValue',
              isRead: 'true',
              interval: '2164',
              texttableentry: 'DeviceDigitalInputSixValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PersistentStorageStatus',
              isRead: 'true',
              interval: '2233',
              texttableentry: 'PersistentStorageStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeSystemConfiguration',
              isRead: 'true',
              interval: '2235',
              texttableentry: 'CascadeSystemConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceSetpoint',
              isRead: 'true',
              interval: '2236',
              texttableentry: 'CascadeDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatus',
              isRead: 'true',
              interval: '2237',
              texttableentry: 'CascadeDeviceStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RemoteWeatherServiceForecast',
              isRead: 'true',
              interval: '2238',
              texttableentry: 'RemoteWeatherServiceForecast',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureSensorSource',
              isRead: 'true',
              interval: '2241',
              texttableentry: 'OutsideTemperatureSensorSource',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FilterRuntime',
              isRead: 'true',
              interval: '2247',
              texttableentry: 'FilterRuntime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentVentilationHeatRecovery',
              isRead: 'true',
              interval: '2248',
              texttableentry: 'CurrentVentilationHeatRecovery',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DigitalSwitchSettingOne',
              isRead: 'true',
              interval: '2249',
              texttableentry: 'DigitalSwitchSettingOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DigitalSwitchSettingTwo',
              isRead: 'true',
              interval: '2250',
              texttableentry: 'DigitalSwitchSettingTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LedStatusOne',
              isRead: 'true',
              interval: '2251',
              texttableentry: 'LedStatusOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LedStatusTwo',
              isRead: 'true',
              interval: '2252',
              texttableentry: 'LedStatusTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputSevenValue',
              isRead: 'true',
              interval: '2253',
              texttableentry: 'DeviceDigitalInputSevenValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationTargetVolumeFlow',
              isRead: 'true',
              interval: '2327',
              texttableentry: 'VentilationTargetVolumeFlow',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationCurrentVolumeFlow',
              isRead: 'true',
              interval: '2328',
              texttableentry: 'VentilationCurrentVolumeFlow',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ControllerBoardTemperatureSensor',
              isRead: 'true',
              interval: '2336',
              texttableentry: 'ControllerBoardTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MinimumVentilationSupplyAirTemperature',
              isRead: 'true',
              interval: '2355',
              texttableentry: 'MinimumVentilationSupplyAirTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentSystemHeatingCoolingLevel',
              isRead: 'true',
              interval: '2356',
              texttableentry: 'CurrentSystemHeatingCoolingLevel',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetStatisticalValues',
              isRead: 'true',
              interval: '2358',
              texttableentry: 'ResetStatisticalValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnvironmentAirQualityInputData',
              isRead: 'true',
              interval: '2360',
              texttableentry: 'EnvironmentAirQualityInputData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationControlMode',
              isRead: 'true',
              interval: '2371',
              texttableentry: 'VentilationControlMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationControllerOperationState',
              isRead: 'true',
              interval: '2372',
              texttableentry: 'VentilationControllerOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationAirVolumeFlowBalancingOffset',
              isRead: 'true',
              interval: '2373',
              texttableentry: 'VentilationAirVolumeFlowBalancingOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationExternalLockFunctionSetting',
              isRead: 'true',
              interval: '2374',
              texttableentry: 'VentilationExternalLockFunctionSetting',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BypassOperationLevel',
              isRead: 'true',
              interval: '2403',
              texttableentry: 'BypassOperationLevel',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HmiWakeupTrigger',
              isRead: 'true',
              interval: '2446',
              texttableentry: 'HmiWakeupTrigger',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupplyAirVolumeFlowDeviceLimit',
              isRead: 'true',
              interval: '2447',
              texttableentry: 'SupplyAirVolumeFlowDeviceLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirVolumeFlowDeviceLimit',
              isRead: 'true',
              interval: '2448',
              texttableentry: 'ExhaustAirVolumeFlowDeviceLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnvironmentAirQualityTargetValues',
              isRead: 'true',
              interval: '2476',
              texttableentry: 'EnvironmentAirQualityTargetValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnvironmentAirQualitySensor',
              isRead: 'true',
              interval: '2477',
              texttableentry: 'EnvironmentAirQualitySensor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomAirHumiditySensor',
              isRead: 'true',
              interval: '2478',
              texttableentry: 'RoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2479',
              texttableentry: 'MixerOneCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2480',
              texttableentry: 'MixerTwoCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2481',
              texttableentry: 'MixerThreeCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2482',
              texttableentry: 'MixerFourCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FrostProtectionStatus',
              isRead: 'true',
              interval: '2489',
              texttableentry: 'FrostProtectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationBypassPosition',
              isRead: 'true',
              interval: '2493',
              texttableentry: 'VentilationBypassPosition',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupplyAirVolumeFlowConfigurationLimit',
              isRead: 'true',
              interval: '2541',
              texttableentry: 'SupplyAirVolumeFlowConfigurationLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExhaustAirVolumeFlowConfigurationLimit',
              isRead: 'true',
              interval: '2542',
              texttableentry: 'ExhaustAirVolumeFlowConfigurationLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationFanModbusId',
              isRead: 'true',
              interval: '2559',
              texttableentry: 'VentilationFanModbusId',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationSupplyFanRuntime',
              isRead: 'true',
              interval: '2566',
              texttableentry: 'VentilationSupplyFanRuntime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationExhaustFanRuntime',
              isRead: 'true',
              interval: '2567',
              texttableentry: 'VentilationExhaustFanRuntime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ProductMatrix',
              isRead: 'true',
              interval: '2593',
              texttableentry: 'ProductMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalPreHeaterMonthMatrix',
              isRead: 'true',
              interval: '2594',
              texttableentry: 'ElectricalPreHeaterMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPreHeaterYearMatrix',
              isRead: 'true',
              interval: '2595',
              texttableentry: 'ElectricalPreHeaterYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationFanAssignmentAvailable',
              isRead: 'true',
              interval: '2598',
              texttableentry: 'VentilationFanAssignmentAvailable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationFanAssignmentSwitch',
              isRead: 'true',
              interval: '2599',
              texttableentry: 'VentilationFanAssignmentSwitch',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterActivation',
              isRead: 'true',
              interval: '2600',
              texttableentry: 'ElectricalHeaterActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterVentilationConfiguration',
              isRead: 'true',
              interval: '2601',
              texttableentry: 'ElectricalHeaterVentilationConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LevelSwitchActivation',
              isRead: 'true',
              interval: '2604',
              texttableentry: 'LevelSwitchActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_QuickModeRuntime',
              isRead: 'true',
              interval: '2605',
              texttableentry: 'QuickModeRuntime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalTriggerActivation',
              isRead: 'true',
              interval: '2606',
              texttableentry: 'ExternalTriggerActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalTriggerSettings',
              isRead: 'true',
              interval: '2607',
              texttableentry: 'ExternalTriggerSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FilterSettings',
              isRead: 'true',
              interval: '2608',
              texttableentry: 'FilterSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CommissioningStatus',
              isRead: 'true',
              interval: '2609',
              texttableentry: 'CommissioningStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyRecoveredCrossHeatExchanger',
              isRead: 'true',
              interval: '2759',
              texttableentry: 'EnergyRecoveredCrossHeatExchanger',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyOwnConsumption',
              isRead: 'true',
              interval: '2760',
              texttableentry: 'EnergyOwnConsumption',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyRecoveredCrossHeatExchangerMonthMatrix',
              isRead: 'true',
              interval: '2772',
              texttableentry: 'EnergyRecoveredCrossHeatExchangerMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyRecoveredCrossHeatExchangerYearMatrix',
              isRead: 'true',
              interval: '2773',
              texttableentry: 'EnergyRecoveredCrossHeatExchangerYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyOwnConsumptionMonthMatrix',
              isRead: 'true',
              interval: '2774',
              texttableentry: 'EnergyOwnConsumptionMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyOwnConsumptionYearMatrix',
              isRead: 'true',
              interval: '2775',
              texttableentry: 'EnergyOwnConsumptionYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AirVolumeFlowSetpoint',
              isRead: 'true',
              interval: '2781',
              texttableentry: 'AirVolumeFlowSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AirVolumeFlowStatus',
              isRead: 'true',
              interval: '2782',
              texttableentry: 'AirVolumeFlowStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationSelfCheckDuration',
              isRead: 'true',
              interval: '2783',
              texttableentry: 'VentilationSelfCheckDuration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterStarts',
              isRead: 'true',
              interval: '2785',
              texttableentry: 'ElectricalHeaterStarts',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPreheaterCurrentPowerConsumption',
              isRead: 'true',
              interval: '2786',
              texttableentry: 'ElectricalPreheaterCurrentPowerConsumption',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationBypassFlapAvailableCount',
              isRead: 'true',
              interval: '2797',
              texttableentry: 'VentilationBypassFlapAvailableCount',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RelativeHumiditySensorSelection',
              isRead: 'true',
              interval: '2798',
              texttableentry: 'RelativeHumiditySensorSelection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeatersShutdownDelay',
              isRead: 'true',
              interval: '2799',
              texttableentry: 'ElectricalHeatersShutdownDelay',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationHeatExchangerType',
              isRead: 'true',
              interval: '2800',
              texttableentry: 'VentilationHeatExchangerType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationFanAssignmentSwitchManufacturing',
              isRead: 'true',
              interval: '2801',
              texttableentry: 'VentilationFanAssignmentSwitchManufacturing',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductIdentification',
              isRead: 'true',
              interval: '2829',
              texttableentry: 'ProductIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_VentilationBypassDynamicVentilationLevel',
              isRead: 'true',
              interval: '2846',
              texttableentry: 'VentilationBypassDynamicVentilationLevel',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ListOfLayerSettingServiceDevices',
              isRead: 'true',
              interval: '2942',
              texttableentry: 'ListOfLayerSettingServiceDevices',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NodeIdOnExternalCan',
              isRead: 'true',
              interval: '2944',
              texttableentry: 'NodeIdOnExternalCan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionElectricalPreHeater',
              isRead: 'true',
              interval: '2946',
              texttableentry: 'EnergyConsumptionElectricalPreHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ListOfLayerSettingServiceDevicesTwo',
              isRead: 'true',
              interval: '2952',
              texttableentry: 'ListOfLayerSettingServiceDevicesTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeatersOperationHours',
              isRead: 'true',
              interval: '2999',
              texttableentry: 'ElectricalHeatersOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AirborneDustSensor',
              isRead: 'true',
              interval: '3102',
              texttableentry: 'AirborneDustSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AirVolatileOrganicCompoundsIndex',
              isRead: 'true',
              interval: '3104',
              texttableentry: 'AirVolatileOrganicCompoundsIndex',
              isWrite: 'false',
            },
          ],
        },
      ],
    };
  }
}
